export enum RfpClientStatus {
    PENDING = "1",
    INVITATION_ACCEPTED = "2",
    INVITATION_REJECTED = "3",
}